const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Auf Mobile: Animation-Stagger begrenzen, um iOS Safari Crashes zu vermeiden.
// Bei vielen gleichzeitig sichtbaren Elementen (z.B. 25 Produkte in einer
// featured-collection) erzeugt die Kaskade zu viele parallele CSS-Animationen.
const IS_MOBILE = window.innerWidth < 750;
const MAX_CASCADE_MOBILE = 4;
const MAX_CASCADE_DESKTOP = 16;

// Scroll in animation logic
function onIntersection(elements, observer) {
  const maxCascade = IS_MOBILE ? MAX_CASCADE_MOBILE : MAX_CASCADE_DESKTOP;

  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade')) {
          // Animation-Stagger begrenzen: Elemente jenseits des Limits
          // werden sofort (ohne Delay) eingeblendet.
          const order = index <= maxCascade ? index : 0;
          elementTarget.setAttribute('style', `--animation-order: ${order};`);
        }
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  // iOS-Crashschutz: Auf Mobile (< 750px) bei vielen animierten Elementen
  // werden ALLE Scroll-Animationen deaktiviert (sofort sichtbar).
  // iOS Safari crasht sonst bei 65+ gleichzeitigen CSS-Animationen auf schweren Seiten.
  const MOBILE_SKIP_THRESHOLD = 15;
  if (IS_MOBILE && animationTriggerElements.length > MOBILE_SKIP_THRESHOLD) {
    animationTriggerElements.forEach((element) => {
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.classList.add(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic – optimiert: ein Observer + ein Scroll-Listener fuer alle Elemente
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;
  const visibleSet = new Set();

  // Ein einziger Observer fuer alle Zoom-Elemente
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        visibleSet.add(entry.target);
      } else {
        visibleSet.delete(entry.target);
      }
    });
  });
  animationTriggerElements.forEach((el) => {
    el.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(el));
    observer.observe(el);
  });

  // Ein einziger Scroll-Listener statt N separate
  var scrollDelay = IS_MOBILE ? 200 : 80;
  window.addEventListener(
    'scroll',
    throttle(() => {
      visibleSet.forEach((element) => {
        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      });
    }, scrollDelay),
    { passive: true }
  );
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
